import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '@components/Navigation';
import Hero from '@sections/Hero';
import Stats from '@sections/Stats';
import Services from '@sections/Services';
import Process from '@sections/Process';
import Pricing from '@sections/Pricing';
import SuccessStories from '@sections/SuccessStories';
import FAQ from '@sections/FAQ';
import Disclaimer from '@sections/Disclaimer';
import CTA from '@sections/CTA';
import Footer from '@components/Footer';
import BookingModal from '@components/BookingModal';
import WhatsAppButton from '@components/WhatsAppButton';
import LegalModal from '@components/LegalModal';

function Landing() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currency, setCurrency] = useState('NGN');
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [activeTab, setActiveTab] = useState('basic');
  const [legalModal, setLegalModal] = useState({ open: false, type: 'terms' });
  const navigate = useNavigate();
  const { user } = useAuth();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const openBooking = (plan = 'basic') => {
    // If user is already logged in, go to dashboard instead of signup
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/auth/signup', { state: { plan } });
    }
  };

  const openLegal = (type) => {
    setLegalModal({ open: true, type });
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 overflow-x-hidden">
      <Navigation 
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        currency={currency}
        setCurrency={setCurrency}
        scrollToSection={scrollToSection}
        openBooking={openBooking}
        isLoggedIn={!!user}
      />

      <main>
        <Hero currency={currency} openBooking={openBooking} scrollToSection={scrollToSection} />
        <Stats />
        <Services />
        <Process />
        <Pricing 
          currency={currency} 
          setCurrency={setCurrency}
          openBooking={openBooking}
        />
        <SuccessStories />
        <FAQ />
        <Disclaimer />
        <CTA openBooking={openBooking} />
      </main>

      <Footer scrollToSection={scrollToSection} openLegal={openLegal} />

      <WhatsAppButton />

      <AnimatePresence>
        {showBookingModal && (
          <BookingModal 
            isOpen={showBookingModal}
            onClose={() => setShowBookingModal(false)}
            currency={currency}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        )}
      </AnimatePresence>

      <LegalModal 
        isOpen={legalModal.open}
        onClose={() => setLegalModal({ ...legalModal, open: false })}
        type={legalModal.type}
      />
    </div>
  );
}

export default Landing;
